import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { User } from '../../services/auth-api/models/index';
import { RoleEnum } from '../../services/auth-api/enums/role.enum';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  constructor(public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    let user: User | undefined = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') ?? '')
      : null;

    let roleAdmin = RoleEnum[RoleEnum.Admin];

    if (!user?.roles || user === null || !user.roles?.includes(roleAdmin)) {
      this.router.navigate(['/auth/login']);
      return true;
    } else if (user) {
      if (!Object.keys(user).length) {
        this.router.navigate(['/auth/login']);
        return true;
      }
    }
    return true;
  }
}
